<template>
    <v-container
        fluid
        grid-list-lg
    >
        <v-row dense>
            <v-col cols=3>
                <v-card
                    class="hidden-xs-only"
                    color="red lighten-1"
                    @click="updateSearch('FAULT')">
                    <v-card-title>Fehler
                        <v-spacer/>
                        {{ countBuildingErrorState }}/{{ buildings.length }}
                    </v-card-title>
                </v-card>
                <v-card
                    class="hidden-sm-and-up"
                    color="red lighten-1"
                    @click="updateSearch('FAULT')">
                    <v-card-text>
                        <strong>
                            {{ countBuildingOfflineState }}/{{ buildings.length }}
                        </strong>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols=3>
                <v-card
                    class="hidden-xs-only"
                    color="orange lighten-1"
                    @click="updateSearch('MAINTENANCE')">
                    <v-card-title>Wartung
                        <v-spacer/>
                        {{ countBuildingWarningState }}/{{ buildings.length }}
                    </v-card-title>
                </v-card>
                <v-card
                    class="hidden-sm-and-up"
                    color="orange lighten-1"
                    @click="updateSearch('MAINTENANCE')">
                    <v-card-text>
                        <strong>
                            {{ countBuildingWarningState }}/{{ buildings.length }}
                        </strong>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols=3>
                <v-card
                    class="hidden-xs-only"
                    color="green lighten-1"
                    @click="updateSearch('ONLINE')">
                    <v-card-title>Automatik
                        <v-spacer/>
                        {{ countBuildingAutomaticOnState }}/{{ buildings.length }}
                    </v-card-title>
                </v-card>
                <v-card
                    class="hidden-sm-and-up"
                    color="green lighten-1"
                    @click="updateSearch('ONLINE')">
                    <v-card-text>
                        <strong>
                            {{ countBuildingAutomaticOnState }}/{{ buildings.length }}
                        </strong>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols=3>
                <v-card
                    class="hidden-xs-only"
                    color="grey lighten-1"
                    @click="updateSearch('OFFLINE')">
                    <v-card-title>Offline
                        <v-spacer/>
                        {{ countBuildingOfflineState }}/{{ buildings.length }}
                    </v-card-title>
                </v-card>
                <v-card
                    class="hidden-sm-and-up"
                    color="grey lighten-1"
                    @click="updateSearch('OFFLINE')">
                    <v-card-text>
                        <strong>
                            {{ countBuildingOfflineState }}/{{ buildings.length }}
                        </strong>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-layout row>
            <v-flex xs12>
                <v-data-table
                    :headers="headers"
                    :items="buildings"
                    class="elevation-1"
                    :search="search"
                    multi-sort
                    sort-by="lastMessage"
                    sort-desc
                    hide-default-footer
                    :items-per-page="buildings.length + 1"
                >
                    <template v-slot:item.state="{ item }">
                        <v-chip :color="getColor(item.state)">
                            <v-icon v-if="item.substate !== 'EMPTY'">{{ getIcon(item.substate) }}</v-icon>
                        </v-chip>
                    </template>
                    <template v-slot:item.street="{ item }">
                        <div>{{ item.address.street }} {{ item.address.houseNumber }}</div>
                    </template>
                    <template v-slot:top>
                        <v-toolbar flat>
                            <v-text-field
                                v-model="search"
                                append-icon="mdi-magnify"
                                label="Suchen/Filtern"
                                single-line
                                clearable
                                hide-details
                                @focusout="storeSearchString"
                            />
                            <v-spacer/>
                            <v-dialog
                                v-model="dialog"
                                max-width="500px">
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        text
                                        class="mb-2"
                                        color="primary"
                                        v-on="on">
                                        Neues Projekt
                                    </v-btn>
                                </template>

                                <v-card>
                                    <v-card-title>
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-container>
                                            <v-row>
                                                <v-col cols="12" sm="6" md="6">
                                                    <v-text-field
                                                        v-model="editedItem.buildingNumber"
                                                        label="Projektnummer">
                                                    </v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6" md="6">
                                                    <v-text-field
                                                        v-model="editedItem.name"
                                                        label="Name">
                                                    </v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-autocomplete
                                                        v-model="editedItem.address.country"
                                                        :items="countryList"
                                                        label="Land"
                                                        item-text="name"
                                                        item-value="alpha"
                                                    >
                                                        <template v-slot:item="data">
                                                            <v-list-item-content>
                                                                <v-list-item-title
                                                                    v-html="data.item.name"></v-list-item-title>
                                                                <v-list-item-subtitle
                                                                    v-html="data.item.alpha"></v-list-item-subtitle>
                                                            </v-list-item-content>
                                                        </template>
                                                    </v-autocomplete>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="6">
                                                    <v-text-field
                                                        v-model="editedItem.address.city"
                                                        label="Stadt">
                                                    </v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="6">
                                                    <v-text-field
                                                        v-model="editedItem.address.postalCode"
                                                        label="Postleitzahl">
                                                    </v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="6">
                                                    <v-text-field
                                                        v-model="editedItem.address.street"
                                                        label="Straße">
                                                    </v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="6">
                                                    <v-text-field
                                                        v-model="editedItem.address.houseNumber"
                                                        label="Nr">
                                                    </v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer/>
                                        <v-btn
                                            color="primary"
                                            text
                                            @click="close">
                                            Abbrechen
                                        </v-btn>
                                        <v-btn
                                            color="primary"
                                            text
                                            @click="save">
                                            Speichern
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-toolbar>
                    </template>
                    <template v-slot:item.lastFault="{ item }">
                        <span
                            :hidden="item.lastFault === '1970-01-01T00:00:00Z'">
                            {{ item.lastFault | moment("L") }}
                            {{ item.lastFault | moment("LTS") }}
                        </span>
                    </template>
                    <template v-slot:item.lastMessage="{ item }">
                        <span>
                            {{ item.lastMessage | moment("L") }}
                            {{ item.lastMessage | moment("LTS") }}
                        </span>
                    </template>
                    <template v-slot:item.availability="{ item }">
                        <span>
                            {{ item.availability != undefined ? "~" + Math.round(item.availability) + "%" : $t('Buildings.calculating') }}
                        </span>
                    </template>
                    <template v-slot:item.action="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    v-bind="attrs"
                                    v-on="on"
                                    class="mr-3"
                                    @click="openDetails(item)"
                                >
                                    mdi-information
                                </v-icon>
                            </template>
                            <span>Details</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    v-bind="attrs"
                                    v-on="on"
                                    class="mr-3"
                                    @click="openMessages(item)"
                                >
                                    mdi-email
                                </v-icon>
                            </template>
                            <span>Nachrichten</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    v-bind="attrs"
                                    v-on="on"
                                    class="mr-3"
                                    @click="openBuildingContactList(item)"
                                >
                                    mdi-account-multiple
                                </v-icon>
                            </template>
                            <span>Kontakte</span>
                        </v-tooltip>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
        <building-contact-list
            style="display: none"
            ref="buildingContactList">
        </building-contact-list>
    </v-container>
</template>

<script>

import countries from '../util/lang-alpha-3'
import axios from "axios";

export default {
    components: {
        BuildingContactList: () => import('./BuildingContactList')
    },
    data: () => ({
        dialog: false,
        isAdmin: false,
        search: '',
        headers: [
            {text: 'Projektnummer', value: 'buildingNumber'},
            {text: 'Status', value: 'state', align: 'center'},
            {text: 'Name', value: 'name', align: 'center'},
            {text: 'Land', value: 'address.country'},
            {text: 'Stadt', value: 'address.city'},
            {text: 'Straße', value: 'address.street'},
            {text: 'Letzte Meldung', value: 'lastMessage', filterable: false},
            {text: 'Letzter Fehler', value: 'lastFault', filterable: false},
            {text: 'Verfügbarkeit', value: 'availability'},
            {text: '', value: 'action', sortable: false, align: 'end', filterable: false}
        ],
        countryList: [],
        editedIndex: -1,
        editedItem: {
            uuid: '',
            buildingNumber: '',
            name: '',
            address: {
                city: '',
                houseNumber: '',
                country: '',
                postalCode: '',
                street: '',
            }
        },
        defaultItem: {
            buildingNumber: '',
            name: '',
            address: {
                city: '',
                houseNumber: '',
                country: '',
                postalCode: '',
                street: '',
            }
        }
    }),
    computed: {
        formTitle() {
            return this.editedIndex === -1 ? 'Projekt anlegen' : 'Projekt ändern'
        },
        buildings() {
            return this.$store.getters.getBuildings
        },
        countBuildingErrorState() {
            let i = 0;
            this.buildings.forEach(value => {
                if (value.state === 'FAULT') i++
            });
            return i
        },
        countBuildingWarningState() {
            let i = 0;
            this.buildings.forEach(value => {
                if (value.state === 'MAINTENANCE') i++
            });
            return i
        },
        countBuildingOfflineState() {
            let i = 0;
            this.buildings.forEach(value => {
                if (value.state === 'OFFLINE') i++
            });
            return i
        },
        countBuildingAutomaticOnState() {
            let i = 0;
            this.buildings.forEach(value => {
                if (value.state === 'ONLINE') i++
            });
            return i
        },
    },
    watch: {
        dialog(val) {
            val || this.close()
        }
    },
    mounted() {
        this.search = this.$store.getters.buildingSearch;
        this.countryList = countries.items;
    },
    methods: {
        updateSearch(name) {
            this.search = name;
            this.storeSearchString();
        },
        deleteItem(item) {
            const index = this.buildings.indexOf(item);
            this.buildings.splice(index, 1)
        },
        close() {
            this.dialog = false;
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1
            }, 300)
        },
        getColor(state) {
            if (state === 'FAULT') return 'red lighten-1';
            else if (state === 'WARNING') return 'orange lighten-1';
            else if (state === 'MAINTENANCE') return 'orange lighten-1';
            else if (state === 'OFFLINE') return 'grey lighten-1';
            else if (state === 'ONLINE') return 'green lighten-1';
            else return 'grey lighten-4'
        },
        getIcon(substate) {
            if (substate === 'AUTOMATIC_ON') return 'mdi-play';
            if (substate === 'AUTOMATIC_STANDBY') return 'mdi-pause';
            if (substate === 'AUTOMATIC_OFF') return 'mdi-alert';
            if (substate === 'MANUEL') return 'mdi-gesture-tap';
            if (substate === 'MAINTENANCE') return 'mdi-tools';
            return ''
        },
        save() {
            this.saveNewBuilding()
            this.close()
        },
        updateBuilding() {
            this.$store.dispatch('updateBuilding', this.editedItem)
        },
        saveNewBuilding() {
            this.$store.dispatch('createBuilding', this.editedItem)
        },
        openMessages(item) {
            this.$router.push({name: 'MessageList', params: {'buildingUuid': item.uuid}})
        },
        openDetails(item) {
            this.$router.push({name: 'Details', params: {'buildingUuid': item.uuid}})
        },
        openBuildingContactList(item) {
            this.$refs.buildingContactList.init(item.uuid)
        },
        storeSearchString() {
            this.$store.commit('storeBuildingSearch', this.search)
        },
        checkIsAdmin() {
            axios.get('/user/api/user/' + this.$keycloak.subject + '/isAdmin/')
                .then(response => {
                    this.isAdmin = response.data.admin;
                })
        },
    }
}
</script>
